// extracted by mini-css-extract-plugin
export default {"page_d":"PaginationBox_page_d__cHpzB","page_l":"PaginationBox_page_l__RhOK0","active":"PaginationBox_active__XH5l4"};